/**
 * The nouns a name lands on.
 *
 * Concrete and slightly wrong, because a concrete noun is what makes a name stick: somebody
 * remembers the Walrus, and nobody remembers Player 3. Kept short so every shape fits inside
 * `MAX_PLAYER_NAME_CHARS` without the sanitizer ever having to cut one.
 */

import type { NameWordList } from '@/identity/playerNameContract';

export const ABSURD_NOUNS: NameWordList = [
  'Walrus',
  'Toaster',
  'Meatball',
  'Pigeon',
  'Goose',
  'Waffle',
  'Badger',
  'Pudding',
  'Gremlin',
  'Trombone',
  'Ferret',
  'Muffin',
  'Wombat',
  'Kettle',
  'Otter',
  'Turnip',
  'Moose',
  'Crumpet',
  'Weasel',
  'Bagpipe',
  'Pelican',
  'Sausage',
  'Llama',
  'Doorknob',
  'Newt',
  'Gherkin',
  'Yak',
  'Biscuit',
  'Heron',
  'Spatula',
];
